import * as React from 'react';
import * as cx from 'classnames';

import { withIntl, IntlProps } from 'ha/i18n';
import { H2 } from 'ha/ui/Headers';
import MediaQuery from 'ha/helpers/MediaQuery';
import Testimonial, { Props } from './Testimonial';
import BellaUrl from 'img-src/landings/bella.jpg';
import GwenUrl from 'img-src/landings/gwen.jpg';
import OliviaUrl from 'img-src/landings/olivia.jpg';

const MOBILE_TESTIMONIALS_COUNT = 2;

const Testimonials: React.SFC<IntlProps> = ({ intl: { T } }) => {
  const testimonials: Props[] = [
    {
      avatarUrl: GwenUrl,
      place: T('HelpFirenze'),
      name: T('Gwendoline Brieux'),
      text: T(
        'I  have been working with HousingAnywhere since 2015 and it has become by far my favorite channel. The relationship we have built with them is what makes this collaboration enjoyable and special. Thanks to HousingAnywhere, my company has managed to double revenues',
      ),
    },
    {
      avatarUrl: OliviaUrl,
      place: T('Pisa'),
      name: T('Olivia Tani'),
      text: T(
        "I found Housing Anywhere looking for a website to rent out my rooms. I have been 6 months and I love it. Why? First of all, because I don’t need to organize viewings, listings and photos are self-explanatory; I can answer the question of the student and easily reach an agreement. Secondly, I like the idea to create an international environment into the flat. Lastly, Housing Anywhere staff is really responsive and helpful. It's nice to know there's someone to count on!",
      ),
    },
    {
      avatarUrl: BellaUrl,
      place: T('Bruxelles'),
      name: T('BELLA V'),
      text: T(
        "Housing Anywhere is a very helpful platform that provides a fast efficient service. The website is easy to access and you can get support from the customer service. As a landlord I was impressed to complete 3 bookings in less than a month. I'd strongly recommend it to landlords who are looking for a successful collaboration.",
      ),
    },
  ];

  return (
    <MediaQuery>
      {({ md, lg }) => (
        <div className={cx(md ? 'p-x-3 m-t-8 m-b-8' : 'm-t-5 m-b-2 p-x-2')}>
          <H2
            className={cx('text-center m-b-0_8 color-black', {
              'font-size-xl': md,
            })}
          >
            {T('What advertisers say about us')}
          </H2>
          <div
            className={cx(
              'text-center text-muted',
              md ? 'm-b-5 font-size-lg' : 'm-b-3',
            )}
          >
            {T("We asked our users why they like us. Here's what they said:")}
          </div>
          {!lg &&
            testimonials
              .slice(0, md ? undefined : MOBILE_TESTIMONIALS_COUNT)
              .map(props => (
                <div key={`${props.name}-${props.place}`} className="m-b-3">
                  <Testimonial {...props} />
                </div>
              ))}
          {lg && (
            <div className="flexbox">
              {testimonials.map((props, index) => (
                <div
                  key={`${props.name}-${props.place}`}
                  className={cx('flex-basis-0 flex-grow-1 flexbox', {
                    'm-r-2': index !== testimonials.length - 1,
                  })}
                >
                  <Testimonial key={props.name} {...props} />
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </MediaQuery>
  );
};

export default withIntl(Testimonials);
